import React, {
  useCallback,
} from 'react';
import {
  useSearchParams,
} from 'react-router-dom';
import Button from 'pages/Dashboard/components/Button';
import {
  useAuth,
} from 'core/hooks';

const DEFAULT_TARGET_URL = '/';

export default function SessionEndedScreen() {
  const [searchParams] = useSearchParams();
  const {
    loginWithRedirect,
  } = useAuth();
  const targetUrl = searchParams.get('targetUrl') ?? DEFAULT_TARGET_URL;

  const handleLogin = useCallback(() => {
    loginWithRedirect({
      appState: {
        targetUrl,
      },
    });
  }, [loginWithRedirect, targetUrl]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-4">
      <div className="w-full max-w-md rounded-lg border border-slate-200 bg-white p-8 shadow-lg">
        <div className="text-center">
          <h1 className="text-2xl font-semibold text-slate-800">
            Session ended
          </h1>
          <p className="mt-2 text-sm text-slate-500">
            Your session was ended in another tab. Sign in again to continue.
          </p>
        </div>
        <Button
          variant="contained"
          color="primary"
          type="button"
          onClick={handleLogin}
          className="!mt-6 !w-full !max-w-[initial]"
        >
          Sign in again
        </Button>
      </div>
    </div>
  );
}
